import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          <h3>🌿 ROOTS</h3>
          <p>Доставка цветов и подарков</p>
          <p>Крым, ЛНР, ДНР, Херсон, Запорожье</p>
        </div>
        <div className="footer-bottom">
          <p>© 2018–2026 ROOTS. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
